import type { User } from "../types/entities/user"

export function getUserFirstName(user: Pick<User, "first_name" | "last_name">): string {
    const first = user.first_name?.trim()
    if (first) return first

    const last = user.last_name?.trim()
    if (last) return last

    return "Профиль"
}

export function getUserInitials(user: Pick<User, "first_name" | "last_name">): string | null {
    const parts = [user.first_name, user.last_name]
        .map(part => part?.trim())
        .filter(Boolean) as string[]

    if (parts.length === 0) return null

    return parts
        .slice(0, 2)
        .map(part => part[0])
        .join("")
        .toUpperCase()
}

export function getTimeGreeting(date = new Date()): string {
    const hour = date.getHours()

    if (hour >= 5 && hour < 12) return "Доброе утро"
    if (hour >= 12 && hour < 18) return "Добрый день"
    if (hour >= 18 && hour < 23) return "Добрый вечер"
    return "Доброй ночи"
}

export function getTimeGreetingWithName(user: Pick<User, "first_name" | "last_name">, date = new Date()): string {
    return `${getTimeGreeting(date)}, ${getUserFirstName(user)}`
}
